module.exports = __webpack_public_path__ + "media/floorplan.0fe29b74.svg";